export default "__VITE_ASSET__CXrDbE2O__"